import React from 'react';
import { BoxWithIconProps } from '../props/BoxWithIconProps';
import '../scss/components/BoxWithIcon.scss';

const BoxWithIcon = ({ props }: { props: BoxWithIconProps }) => {
  const iconClassName = `${props.className} icon`;
  return (
    <>
      <div className='child' >
        
          <div>
            <a
              href={props.link}
              target='_blank'
              rel='noopener noreferrer'
              className={props.className}
              style={{cursor:'pointer'}}
            >
              <props.svg className={iconClassName} data-testid='icon' />
              {props.text}
            </a>
          </div>
        
      </div>
    </>
  );
};

export default BoxWithIcon;
